var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { MessageGroup } from '../../store/message/message';
import { FileAlert } from '../../conversation/alert/file-alert';
import PeopleInChat from '../../conversation/messages/peopleInChat';
var Messages = (function (_super) {
    __extends(Messages, _super);
    function Messages(props) {
        var _this = _super.call(this, props) || this;
        Object.defineProperty(_this, "messagesContainerDiv", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "unreadMessageCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "renderedMessagesCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "unreadMessageElementPosition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.renderGroups = _this.renderGroups.bind(_this);
        _this.renderMessage = _this.renderMessage.bind(_this);
        _this.unreadMessageCount = _this.props.unreadMessageCount;
        return _this;
    }
    Object.defineProperty(Messages.prototype, "componentDidMount", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.getMessages();
        }
    });
    Object.defineProperty(Messages.prototype, "componentDidUpdate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.onUpdatedMessages();
        }
    });
    Object.defineProperty(Messages.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a = this.props, masterAccountId = _a.masterAccountId, userId = _a.userId, employeeSourceId = _a.employeeSourceId;
            return (React.createElement("div", { className: "body" },
                this.renderFileAlert(),
                React.createElement(PeopleInChat, { store: this.props.store, masterAccountId: masterAccountId, userId: userId, employeeSourceId: employeeSourceId }),
                React.createElement("div", { ref: function (element) { return _this.messagesContainerDiv = element; }, className: "messages" },
                    React.createElement("ul", null, this.renderGroups()))));
        }
    });
    Object.defineProperty(Messages.prototype, "renderGroups", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var messageStore = this.props.store.messageStore;
            var messages = [];
            var _loop_1 = function (group) {
                var groupValue = Number(group);
                if (isNaN(groupValue)) {
                    return "continue";
                }
                var groupedMessages = messageStore.messages.filter(function (message) { return message.getMessageGroup() === groupValue; });
                messages.push.apply(messages, groupedMessages.map(this_1.renderMessage));
            };
            var this_1 = this;
            for (var _i = 0, _a = Object.keys(MessageGroup); _i < _a.length; _i++) {
                var group = _a[_i];
                _loop_1(group);
            }
            return messages;
        }
    });
    Object.defineProperty(Messages.prototype, "getMessages", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var messageStore, _a, masterAccountId, userId, entityType, entityId;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            messageStore = this.props.store.messageStore;
                            _a = this.props, masterAccountId = _a.masterAccountId, userId = _a.userId, entityType = _a.entityType, entityId = _a.entityId;
                            return [4, messageStore.getMessages(masterAccountId, userId, entityType, entityId)];
                        case 1:
                            _b.sent();
                            return [4, this.onMessagesReceived()];
                        case 2:
                            _b.sent();
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(Messages.prototype, "onUpdatedMessages", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var messageStore = this.props.store.messageStore;
            if (this.renderedMessagesCount === messageStore.messages.length) {
                return;
            }
            this.renderedMessagesCount = messageStore.messages.length;
            if (this.unreadMessageCount === 0) {
                this.scrollToLastMessage();
                return;
            }
            this.scrollToLastUnreadMessage(this.unreadMessageCount);
        }
    });
    Object.defineProperty(Messages.prototype, "scrollToLastUnreadMessage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (unreadMessageCount) {
            if (this.unreadMessageElementPosition != null && this.messagesContainerDiv) {
                this.messagesContainerDiv.scrollTop = this.unreadMessageElementPosition;
                return;
            }
            this.scrollToLastMessage();
        }
    });
    Object.defineProperty(Messages.prototype, "scrollToLastMessage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this.messagesContainerDiv) {
                this.messagesContainerDiv.scrollTop = this.messagesContainerDiv.scrollHeight;
            }
        }
    });
    Object.defineProperty(Messages.prototype, "onMessagesReceived", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var messageStore, _a, masterAccountId, entityType, entityId;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            messageStore = this.props.store.messageStore;
                            _a = this.props, masterAccountId = _a.masterAccountId, entityType = _a.entityType, entityId = _a.entityId;
                            return [4, messageStore.setLastReadMessage(masterAccountId, entityType, entityId, messageStore.lastMessageId)];
                        case 1:
                            _b.sent();
                            this.unreadMessageCount = 0;
                            if (this.props.onRead) {
                                this.props.onRead();
                            }
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(Messages.prototype, "renderMessage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message, messageIndex, messages) {
            var _this = this;
            var oldestUnreadMessageIndex = messages.length - this.unreadMessageCount;
            return (React.createElement("li", { ref: function (element) { return _this.getOldestUnreadMessagePosition(element, messageIndex, oldestUnreadMessageIndex); }, key: message.messageId },
                React.createElement("div", { hidden: messageIndex > 0, className: "message-date" },
                    React.createElement("span", { className: "pxl-text-c11-6 pxl-padding-sm" }, message.printGroupDate)),
                React.createElement("div", { className: "flex-group" },
                    React.createElement("div", null,
                        React.createElement("span", { className: "initial pxl-text-violet" }, message.displayInitial)),
                    React.createElement("div", null,
                        React.createElement("div", { className: message.getHeaderClasses(this.props.userId) },
                            React.createElement("div", { className: "sender-name pxl-text-sm" },
                                React.createElement("span", { className: "name" }, message.userName),
                                "\u00A0",
                                React.createElement("span", { className: "pxl-text-c11-6" }, message.printDate))),
                        this.renderMessageContent(message)))));
        }
    });
    Object.defineProperty(Messages.prototype, "getOldestUnreadMessagePosition", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (messageElement, messageIndex, oldestUnreadMessageIndex) {
            if (!messageElement) {
                return;
            }
            if (messageIndex === oldestUnreadMessageIndex) {
                this.unreadMessageElementPosition = messageElement.offsetTop;
            }
        }
    });
    Object.defineProperty(Messages.prototype, "renderMessageContent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
            if (message.isBeingSent === false && message.message.trim().length === 0 && !message.blobId) {
                return null;
            }
            return (React.createElement("div", { className: message.getContentClasses(this.props.userId) },
                this.renderContentPerLine(message.message),
                this.renderUploadedFile(message),
                React.createElement("span", { hidden: message.isBeingSent === false, className: "pxl-text-c11-2 pxl-text-right" },
                    React.createElement("i", { className: "icon-animate-spin icon-spin" }))));
        }
    });
    Object.defineProperty(Messages.prototype, "renderContentPerLine", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (content) {
            if (content.trim().length === 0) {
                return null;
            }
            return content.split('\n').map(function (line, index) { return (React.createElement("p", { key: index }, line)); });
        }
    });
    Object.defineProperty(Messages.prototype, "renderUploadedFile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (message) {
            var _this = this;
            if (!message.blobId) {
                return null;
            }
            return (React.createElement("span", { className: message.getAttachmentClasses(this.props.userId), onClick: function (event) { return _this.getAttachment(event, message); } },
                message.filename,
                React.createElement("span", { className: "icon-download" }),
                React.createElement("span", { hidden: message.isDownloading === false, className: "pxl-text-c11-2 pxl-text-right" },
                    React.createElement("i", { className: "icon-animate-spin icon-spin" }))));
        }
    });
    Object.defineProperty(Messages.prototype, "getAttachment", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, message) {
            event.stopPropagation();
            var masterAccountId = this.props.masterAccountId;
            message.getAttachment(masterAccountId);
        }
    });
    Object.defineProperty(Messages.prototype, "renderFileAlert", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var messageStore = this.props.store.messageStore;
            if (messageStore.hasFileError === false || !messageStore.fileError) {
                return null;
            }
            return (React.createElement(FileAlert, { error: messageStore.fileError, onClose: messageStore.clearFileError }));
        }
    });
    return Messages;
}(React.Component));
export { Messages };
export default inject('store')(observer(Messages));
